export class ZxcvbnLoad {
  private static promise;

  public static asyncLoad() {
    if (!ZxcvbnLoad.promise) {
      ZxcvbnLoad.promise = new Promise((resolve, reject) => {
        let url = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js',
          id = 'zxcvbnscript';
        let head = document.getElementsByTagName('head')[0];
        let script = <HTMLScriptElement>head.querySelector(`script#${id}`);

        if (script == null || script.src != url) {
          script = document.createElement('script');
          script.type = 'text/javascript';
          script.async = true;
          script.onload = () => {
            resolve(global['zxcvbn']);
          };
          script.onerror = function () {
            reject();
          };
          script.id = id;
          script.src = url;
          head.appendChild(script);
        } else {
          resolve(global['zxcvbn']);
        }
      });
    }

    return ZxcvbnLoad.promise;
  }
}
